import { render, staticRenderFns } from "./DefaultPaySectionPage.vue?vue&type=template&id=58ee4f72&"
import script from "./DefaultPaySectionPage.vue?vue&type=script&lang=js&"
export * from "./DefaultPaySectionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports